module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"normalVisit":"Visita Nutrizionale Annullata!","freeVisit":"Incontro Conoscitivo Annullato!","mealPlan":"Consegna e spiegazione del piano Annullata!"}}')
  delete Component.options._Ctor
}
